import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import store from '@/store';
import namespaces from '@/store/namespaces';
import { I18nMutationTypes } from '@/store/modules/i18n/mutations';
const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  pt: {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  }
};

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  },
  pt: {
    currency: {
      style: 'currency',
      currency: 'BRL',
      currencyDisplay: 'symbol'
    }
  }
};

function loadLocaleMessages(): LocaleMessages {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messagesLocale: LocaleMessages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messagesLocale[locale] = locales(key);
    }
  });
  return messagesLocale;
}

Vue.prototype.$i18nRouter = {
  path: (to: string) => {
    return (store.state[namespaces.I18N].locale ===
      store.state[namespaces.I18N].fallbackLocale) ? `/${to}` :
      `/${store.state[namespaces.I18N].locale}/${to}`;
  }
};

const messages = loadLocaleMessages();
store.commit(`${namespaces.I18N}/${I18nMutationTypes.SET_MESSAGES}`, messages);

const options = {
  locale: store.state[namespaces.I18N].locale,
  fallbackLocale: store.state[namespaces.I18N].fallbackLocale,
  messages,
  dateTimeFormats,
  numberFormats
};


Vue.use(VueI18n, options);

export default new VueI18n(options);
